import React from 'react';
import Hero from './components/about-us/vision-mission/Hero';
import Main from './components/about-us/vision-mission/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const VisionMission = () => {
  return (
    <div>
        <Hero />
        <Main />
        <ImportantLinksSlider />
    </div>
  )
}

export default VisionMission;